import React, { FunctionComponent, ReactNode } from 'react';
import sizeMe from 'react-sizeme';

const SizableChartWrapper: FunctionComponent<{ children?: ReactNode }> = ({ children }) =>
  <>{children}</>;

export default sizeMe({
  monitorHeight: true,
  monitorWidth: true,
  monitorPosition: false,
})(SizableChartWrapper);
